import { securedAxiosInstance } from "@/api/axios";

const initialState = {};

export default {
  namespaced: true,
  state: initialState,
  getters: {},
  mutations: {},
  actions: {
    async delete(_, id) {
      return await securedAxiosInstance.delete(`/sellers/${id}`);
    },
  },
};
